import React, { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Game from './components/Game'
import { AuthProvider } from './context/AuthContext'
import { LoginPage } from './pages/Auth/Login'
import { RegisterPage } from './pages/Auth/Register'
import { BillingPage } from './pages/Billing'
import styled from 'styled-components'

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
`

const GameHome: React.FC = () => {
  const [, setPanelCollapse] = useState(false)
  const onPanelCollapse = (value: boolean) => {
    setPanelCollapse(value)
  }
  return (
    <AppContainer>
      <Game onPanelCollapse={onPanelCollapse} />
    </AppContainer>
  )
}

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<GameHome />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/billing" element={<BillingPage />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
